import { anim, prog, stagger } from '../../../../motion'
import { Line } from '../../../../v2/kit'
import { useCopy } from '../../../i18n'
import berg from '../../media/eisberg.png'
import { MaskText } from '../../stage/fx'

// Partikel bilden einen Lebenslauf, der dann zu Boden rieselt. Danach taucht die Kamera am Eisberg ab
export const PROBLEM_PARTICLES = [
  [
    0.04,
    (w, h, narrow) => ({
      type: 'cv',
      x: narrow ? w / 2 : w * 0.72,
      y: narrow ? h * 0.68 : h / 2,
      width: narrow ? w * 0.5 : Math.min(w * 0.22, h * 0.42),
      height: narrow ? w * 0.66 : Math.min(w * 0.29, h * 0.56)
    })
  ],
  [
    0.28,
    (w, h, narrow) => ({
      type: 'cv',
      x: narrow ? w / 2 : w * 0.72,
      y: narrow ? h * 0.68 : h / 2,
      width: narrow ? w * 0.5 : Math.min(w * 0.22, h * 0.42),
      height: narrow ? w * 0.66 : Math.min(w * 0.29, h * 0.56)
    })
  ],
  [0.42, () => ({ type: 'scatter', top: 0.9, bottom: 1.04, alpha: 0.28 })],
  [1, () => ({ type: 'scatter', top: 0.9, bottom: 1.04, alpha: 0.2 })]
]

export default function DmsProblem() {
  const c = useCopy('problem')
  const s = useCopy('show')

  return (
    <div className='sc-full'>
      <div className='dms-cv-lines'>
        <div className='sc-h2'>
          <MaskText text={s.cv[0]} at={[0.02, 0.1]} out={[0.3, 0.35]} />
        </div>
        <div className='sc-h2 sc-dim'>
          <MaskText text={s.cv[1]} at={[0.08, 0.16]} out={[0.3, 0.35]} />
        </div>
        <div className='sc-h2 sc-grad'>
          <MaskText text={s.cv[2]} at={[0.16, 0.24]} out={[0.3, 0.35]} />
        </div>
      </div>

      <div className='dms-dive'>
        <Line at={[0.4, 0.46]} y={30} className='sc-eyebrow'>
          {c.eyebrow}
        </Line>
        <div className='sc-h2'>
          <MaskText text={s.dive} at={[0.42, 0.52]} />
        </div>
        <div className='dms-problems'>
          {c.problems.map((p, i) => (
            <div
              key={p.title}
              className='dms-problem'
              style={anim({ at: stagger(0.78, 0.05, 0.08, i), x: -40, y: 0 })}
            >
              <span className='dms-problem__num'>0{i + 1}</span>
              <div>
                <div className='dms-problem__title'>{p.title}</div>
                <div className='dms-problem__text'>{p.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        className='dms-berg'
        style={{
          ...prog([0.36, 0.76]),
          ...anim({ at: [0.34, 0.42], y: 160 })
        }}
      >
        <div className='dms-berg__move'>
          <img src={berg} alt='' className='dms-berg__img' />
          <div
            className='dms-berg__card dms-berg__card--visible'
            style={anim({ at: [0.44, 0.5], x: 30, y: 0 })}
          >
            <b>{c.visible}</b>
            {c.visibleItems.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
          <div
            className='dms-berg__card dms-berg__card--hidden'
            style={anim({ at: [0.52, 0.58], x: -30, y: 0 })}
          >
            <b>{c.hidden}</b>
            {c.hiddenItems.map((item, i) => (
              <span
                key={item}
                style={anim({
                  at: stagger(0.56, 0.035, 0.05, i),
                  x: -16,
                  y: 0
                })}
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
